module.exports = __webpack_public_path__ + "media/images/noimage-6201c96af49e73cc359e0f9e5f591094.jpg";